import Vue from 'vue';
import Router from 'vue-router';
/*import index from 'components/edas';
import api from 'components/edas/api';
import home from 'components/edas/home';
import edas from 'components/edas/edas';
import ImportLog from 'components/edas/importLog';
import BindingLog from 'components/edas/bindingLog';
import login from 'components/edas/login';
import error from 'components/edas/error';
import list from 'components/edas/list';
import application from 'components/edas/application';
import appdetails from 'components/edas/appdetails';
// api
import usageMethod from 'components/document/api_usage_method'
import ProductGuide from 'components/document/api_product_guide'
import apiFileList from 'components/document/api_file_list';
import apiFileListByName from 'components/document/api_file_info_by_name';
import apiFileListByNeid from 'components/document/api_file_info_by_neid';
import apiFileContent from 'components/document/api_file_content';
import apiFileUpload from 'components/document/api_file_need_upload_chunks';
import uploadChunk from 'components/document/api_file_chunk_uploadchunk';
import commitChunkUpload from 'components/document/api_file_chunk_commitchunkupload'
import fileopsAuth from 'components/document/api_file_fileopsauth';
import fileUploadBypath from 'components/document/api_file_uploadbyopsauth';
import fileCheckChunked from 'components/document/api_file_chunked_checkblockbyopsauth';
import fileUploadChunked from 'components/document/api_file_chunked_uploadbyopsauth';
import fileChunkCommitUpload from 'components/document/api_file_chunk_commitchunkupload_idt';
import fileDownloadById from 'components/document/api_file_download_by_id';
import fileDownloadByPath from 'components/document/api_file_download_by_path';
import fileCreateFolder from 'components/document/api_file_create_folder';
import fileDelete from 'components/document/api_file_delete';
import fileCopy from 'components/document/api_file_copy';
import apifileMove from 'components/document/api_file_move';
import apifileRename from 'components/document/api_file_rename';
import apifilePreview from 'components/document/api_file_preview';
import apideliveryCreate from 'components/document/api_delivery_create';
import apideliveryDelete from 'components/document/api_delivery_delete';
import getDeliveryInfo from 'components/document/api_get_delivery_info';
import apiTeamCreate from 'components/document/api_team_create';
import apiTeamList from 'components/document/api_team_list';
import apiTeamInfo from 'components/document/api_team_info';
import apiTeamUpdate from 'components/document/api_team_update';
import apiTeamDelete from 'components/document/api_team_delete';
import apiCreateUser from 'components/document/api_create_user';
import apiUserList from 'components/document/api_user_list';
import apiUserInfo from 'components/document/userInfo';
import apiUpdateUserInfo from 'components/document/userUpdate';
import apiBatchFrozenUser from 'components/document/userBatchFreeze';
import apiBatchActivateUser from 'components/document/userBatchActivate';
import apiUserTeamCreate from 'components/document/userTeamCreate';
import apiUserTeamDelete from 'components/document/userTeamDelete';*/

const index = () => import('components/edas');
const api = () => import('components/edas/api');
const home = () => import('components/edas/home');
const edas = () => import('components/edas/edas');
const ImportLog = () => import('components/edas/importLog');
const BindingLog = () => import('components/edas/bindingLog');
const login = () => import('components/edas/login');
const error = () => import('components/edas/error');
const list = () => import('components/edas/list');
const application = () => import('components/edas/application');
const appdetails = () => import('components/edas/appdetails');
// api

const usageMethod = () => import('components/document/api_usage_method');
const ProductGuide = () => import('components/document/api_product_guide');
const apiFileList = () => import('components/document/api_file_list');
const apiFileListByName = () => import('components/document/api_file_info_by_name');
const apiFileListByNeid = () => import('components/document/api_file_info_by_neid');
const apiFileContent = () => import('components/document/api_file_content');
const apiFileUpload = () => import('components/document/api_file_need_upload_chunks');
const uploadChunk = () => import('components/document/api_file_chunk_uploadchunk');
const commitChunkUpload = () => import('components/document/api_file_chunk_commitchunkupload');
const fileopsAuth = () => import('components/document/api_file_fileopsauth');
const fileUploadBypath = () => import('components/document/api_file_uploadbyopsauth');
const fileCheckChunked = () => import('components/document/api_file_chunked_checkblockbyopsauth');
const fileUploadChunked = () => import('components/document/api_file_chunked_uploadbyopsauth');
const fileChunkCommitUpload = () => import('components/document/api_file_chunk_commitchunkupload_idt');
const fileDownloadById = () => import('components/document/api_file_download_by_id');
const fileDownloadByPath = () => import('components/document/api_file_download_by_path');
const fileCreateFolder = () => import('components/document/api_file_create_folder');
const fileDelete = () => import('components/document/api_file_delete');
const fileCopy = () => import('components/document/api_file_copy');
const apifileMove = () => import('components/document/api_file_move');
const apifileRename = () => import('components/document/api_file_rename');
const apifilePreview = () => import('components/document/api_file_preview');
const apideliveryCreate = () => import('components/document/api_delivery_create');
const apideliveryDelete = () => import('components/document/api_delivery_delete');
const getDeliveryInfo = () => import('components/document/api_get_delivery_info');
const apiTeamCreate = () => import('components/document/api_team_create');
const apiTeamList = () => import('components/document/api_team_list');
const apiTeamInfo = () => import('components/document/api_team_info');
const apiTeamUpdate = () => import('components/document/api_team_update');
const apiTeamDelete = () => import('components/document/api_team_delete');
const apiCreateUser = () => import('components/document/api_create_user');
const apiUserList = () => import('components/document/api_user_list');
const apiUserInfo = () => import('components/document/userInfo');
const apiUpdateUserInfo = () => import('components/document/userUpdate');
const apiBatchFrozenUser = () => import('components/document/userBatchFreeze');
const apiBatchActivateUser = () => import('components/document/userBatchActivate');
const apiUserTeamCreate = () => import('components/document/userTeamCreate');
const apiUserTeamDelete = () => import('components/document/userTeamDelete');

Vue.use(Router);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            children: [
                {
                    path: '/',
                    name: 'api',
                    component: api,
                    redirect: '/api/ProductGuide',
                    children: [
                        {
                            path: '/api/ProductGuide',
                            name: 'ProductGuide',
                            component: ProductGuide
                        },
                        {
                            path: '/api/usageMethod',
                            name: 'usageMethod',
                            component: usageMethod
                        },
                        {
                            path: '/api/apiFileList',
                            name: 'apiFileList',
                            component: apiFileList
                        },
                        {
                            path: '/api/apiFileListByName',
                            name: 'apiFileListByName',
                            component: apiFileListByName
                        },
                        {
                            path: '/api/apiFileListByNeid',
                            name: 'apiFileListByNeid',
                            component: apiFileListByNeid
                        },
                        {
                            path: '/api/apiFileContent',
                            name: 'apiFileContent',
                            component: apiFileContent
                        },
                        {
                            path: '/api/apiFileUpload',
                            name: 'apiFileUpload',
                            component: apiFileUpload
                        },
                        {
                            path: '/api/uploadChunk',
                            name: 'uploadChunk',
                            component: uploadChunk
                        },
                        {
                            path: '/api/commitChunkUpload',
                            name: 'commitChunkUpload',
                            component: commitChunkUpload
                        },
                        {
                            path: '/api/fileopsAuth',
                            name: 'fileopsAuth',
                            component: fileopsAuth
                        },
                        {
                            path: '/api/fileUploadBypath',
                            name: 'fileUploadBypath',
                            component: fileUploadBypath
                        },
                        {
                            path: '/api/fileCheckChunked',
                            name: 'fileCheckChunked',
                            component: fileCheckChunked
                        },
                        {
                            path: '/api/fileUploadChunked',
                            name: 'fileUploadChunked',
                            component: fileUploadChunked
                        },
                        {
                            path: '/api/fileChunkCommitUpload',
                            name: 'fileChunkCommitUpload',
                            component: fileChunkCommitUpload
                        },
                        {
                            path: '/api/fileDownloadById',
                            name: 'fileDownloadById',
                            component: fileDownloadById
                        },
                        {
                            path: '/api/fileDownloadByPath',
                            name: 'fileDownloadByPath',
                            component: fileDownloadByPath
                        },
                        {
                            path: '/api/fileCreateFolder',
                            name: 'fileCreateFolder',
                            component: fileCreateFolder
                        },
                        {
                            path: '/api/fileDelete',
                            name: 'fileDelete',
                            component: fileDelete
                        },
                        {
                            path: '/api/fileCopy',
                            name: 'fileCopy',
                            component: fileCopy
                        },
                        {
                            path: '/api/fileMove',
                            name: 'fileMove',
                            component: apifileMove
                        },
                        {
                            path: '/api/fileRename',
                            name: 'fileRename',
                            component: apifileRename
                        },
                        {
                            path: '/api/filePreview',
                            name: 'filePreview',
                            component: apifilePreview
                        },
                        {
                            path: '/api/deliveryCreate',
                            name: 'deliveryCreate',
                            component: apideliveryCreate
                        },
                        {
                            path: '/api/deliveryDelete',
                            name: 'deliveryDelete',
                            component: apideliveryDelete
                        },
                        {
                            path: '/api/getDeliveryInfo',
                            name: 'getDeliveryInfo',
                            component: getDeliveryInfo
                        },
                        {
                            path: '/api/teamCreate',
                            name: 'teamCreate',
                            component: apiTeamCreate
                        },
                        {
                            path: '/api/teamList',
                            name: 'teamList',
                            component: apiTeamList
                        },
                        {
                            path: '/api/teamInfo',
                            name: 'teamInfo',
                            component: apiTeamInfo
                        },
                        {
                            path: '/api/teamUpdate',
                            name: 'teamUpdate',
                            component: apiTeamUpdate
                        },
                        {
                            path: '/api/teamDelete',
                            name: 'teamDelete',
                            component: apiTeamDelete,
                        },
                        {
                            path: '/api/createUser',
                            name: 'createUser',
                            component: apiCreateUser
                        },
                        {
                            path: '/api/userList',
                            name: 'userList',
                            component: apiUserList
                        },
                        {
                            path: '/api/userInfo',
                            name: 'userInfo',
                            component: apiUserInfo
                        },
                        {
                            path: '/api/userUpdate',
                            name: 'userUpdate',
                            component: apiUpdateUserInfo
                        },
                        {
                            path: '/api/userBatchFreeze',
                            name: 'userBatchFreeze',
                            component: apiBatchFrozenUser
                        },
                        {
                            path: '/api/userBatchActivate',
                            name: 'userBatchActivate',
                            component: apiBatchActivateUser
                        },
                        {
                            path: '/api/userTeamCreate',
                            name: 'userTeamCreate',
                            component: apiUserTeamCreate
                        },
                        {
                            path: '/api/userTeamDelete',
                            name: 'userTeamDelete',
                            component: apiUserTeamDelete
                        }
                    ]
                },
            ]
        },
        {
            path: '/edas',
            name: 'edas',
            component: edas,
            children: [
                {
                    path: '/edas',
                    name: 'home',
                    component: home
                },
                {
                    path: '/edas/importLog',
                    name: 'importLog',
                    component: ImportLog,
                },
                {
                    path: '/edas/bindingLog',
                    name: 'bindingLog',
                    component: BindingLog,
                },
                {
                    path: '/edas/list',
                    name: 'list',
                    component: list,
                },
                {
                    path: '/edas/application',
                    name: 'application',
                    component: application,
                },
                {
                    path: '/edas/appdetails/:num',
                    name: 'appdetails',
                    component: appdetails,
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login,
        },
        {
            path: '/*',
            name: 'error',
            component: error,
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js